import modular from 'modujs';
import * as modules from './modules/all';

const app = new modular({
    modules: modules
});

app.init(app);